module.exports = __webpack_public_path__ + "img/34_42.a7a39292.png";